module.exports = __webpack_public_path__ + "img/fuwubaoz_1.3017cb6b.png";